/* Royal Skin Glow — scripts du thème (sans dépendance). */
(function () {
  'use strict';

  var RS = window.RoyalSkin || {};
  var routes = RS.routes || {};
  var strings = RS.strings || {};

  function $(selector, scope) { return (scope || document).querySelector(selector); }
  function $$(selector, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }

  /* ---------- Format des prix (pour le changement de variante) ---------- */
  function formatMoney(cents) {
    var format = RS.moneyFormat || '{{amount_no_decimals_with_space_separator}} FCFA';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      /* Franc CFA : pas de centimes, comme le filtre money de Shopify */
      if (number % 100 === 0) precision = 0;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2);
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ', ',');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return withDelimiters(cents, 2, ' ', '.');
        default: return withDelimiters(cents, 0, ' ', ',');
      }
    });
  }

  /* ---------- En-tête ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Menu mobile ---------- */
  var mobileMenu = $('[data-mobile-menu]');
  var menuToggle = $('[data-menu-open]');
  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.hidden = false;
    document.body.classList.add('is-locked', 'menu-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    var closeBtn = $('.mobile-menu__head [data-menu-close]', mobileMenu);
    if (closeBtn) closeBtn.focus();
  }
  function closeMenu() {
    if (!mobileMenu || mobileMenu.hidden) return;
    mobileMenu.hidden = true;
    document.body.classList.remove('menu-open');
    if (!document.body.classList.contains('cart-open')) document.body.classList.remove('is-locked');
    if (menuToggle) { menuToggle.setAttribute('aria-expanded', 'false'); menuToggle.focus(); }
  }

  /* ---------- Tiroir du panier ---------- */
  function getDrawer() { return $('[data-cart-drawer]'); }
  var lastFocus = null;

  function openCart() {
    var drawer = getDrawer();
    if (!drawer) { window.location.href = routes.cart || '/cart'; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('is-locked', 'cart-open');
    var closeBtn = $('.cart-drawer__head [data-cart-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }
  function closeCart() {
    var drawer = getDrawer();
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    drawer.classList.remove('is-refreshing');
    document.body.classList.remove('cart-open');
    if (!document.body.classList.contains('menu-open')) document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function bumpCart() {
    $$('.cart-button').forEach(function (el) {
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  }

  function updateCount(count, bump) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !(count > 0);
    });
    $$('.cart-button').forEach(function (el) {
      el.setAttribute('aria-label', 'Panier, ' + count + ' article(s)');
    });
    if (bump !== false) bumpCart();
  }

  /* Annonce discrète pour les lecteurs d'écran */
  var live = document.createElement('p');
  live.className = 'visually-hidden';
  live.setAttribute('aria-live', 'polite');
  document.body.appendChild(live);
  function announce(text) {
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }

  /* La photo du produit s'envole vers l'icône du panier */
  function flyToCart(img, done) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var target = $$('.cart-button').filter(function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
    })[0];
    if (!img || !target || reduce || !img.animate) { done(); return; }
    var from = img.getBoundingClientRect();
    if (!from.width || from.bottom < 0 || from.top > window.innerHeight) { done(); return; }
    var to = target.getBoundingClientRect();
    var size = Math.min(from.width, from.height, 140);
    var startX = from.left + from.width / 2 - size / 2;
    var startY = from.top + from.height / 2 - size / 2;
    var dx = to.left + to.width / 2 - (startX + size / 2);
    var dy = to.top + to.height / 2 - (startY + size / 2);
    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src;
    clone.alt = '';
    clone.className = 'fly-to-cart';
    clone.style.left = startX + 'px';
    clone.style.top = startY + 'px';
    clone.style.width = size + 'px';
    clone.style.height = size + 'px';
    document.body.appendChild(clone);
    var flight = clone.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - 70) + 'px) scale(0.55)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.12)', opacity: 0.3 }
    ], { duration: 750, easing: 'cubic-bezier(0.45, 0, 0.25, 1)' });
    flight.onfinish = function () { clone.remove(); done(); };
  }

  function renderDrawer(html, quiet) {
    if (!html) return;
    var drawer = getDrawer();
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer]', parsed);
    if (!drawer || !fresh) return;
    var wasOpen = !drawer.hidden;
    if (wasOpen) drawer.classList.add('is-refreshing');
    drawer.innerHTML = fresh.innerHTML;
    drawer.setAttribute('data-count', fresh.getAttribute('data-count'));
    drawer.hidden = !wasOpen;
    updateCount(parseInt(fresh.getAttribute('data-count'), 10) || 0, !quiet);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var message = (data && (data.description || data.message)) || strings.error;
          throw new Error(message);
        }
        return data;
      });
    });
  }

  /* Ajout au panier (cartes produits et fiche produit) */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-rs-add]');
    if (!form) return;
    event.preventDefault();

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var button = form.querySelector('[data-add-button]');
    var label = form.querySelector('[data-add-label]');
    var errorBox = form.querySelector('[data-form-error]');
    if (!idInput || !idInput.value) return;

    var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var originalLabel = label ? label.textContent : '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    if (label) label.textContent = strings.adding || 'Ajout…';
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }

    postJSON(routes.cartAdd || '/cart/add.js', {
      items: [{ id: parseInt(idInput.value, 10), quantity: quantity }],
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    }).then(function (data) {
      var openOnAdd = RS.cart && RS.cart.openOnAdd;
      renderDrawer(data.sections && data.sections['cart-drawer'], !openOnAdd);
      if (label) label.textContent = strings.added || 'Ajouté !';
      if (button) button.classList.add('is-added');
      if (openOnAdd) {
        openCart();
      } else {
        /* On reste sur la page : la cliente continue ses achats */
        var scope = form.closest('.product-card, [data-product-section]');
        var img = scope && (scope.querySelector('.product-gallery__slide.is-active img') || scope.querySelector('.product-card__img'));
        flyToCart(img, bumpCart);
        var success = form.querySelector('[data-form-success]');
        if (success) {
          success.hidden = false;
          clearTimeout(form.rsSuccessTimer);
          form.rsSuccessTimer = setTimeout(function () { success.hidden = true; }, 6000);
        }
        announce(strings.addedToCart || 'Produit ajouté au panier');
      }
      setTimeout(function () {
        if (label) label.textContent = originalLabel;
        if (button) button.classList.remove('is-added');
      }, 1800);
    }).catch(function (error) {
      if (label) label.textContent = originalLabel;
      if (errorBox) { errorBox.textContent = error.message; errorBox.hidden = false; }
      else window.alert(error.message);
    }).then(function () {
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    });
  });

  /* Quantités et suppression dans le panier */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-line-change]');
    if (!trigger) return;
    var line = trigger.closest('[data-line-key]');
    if (!line) return;
    event.preventDefault();
    var quantity = Math.max(0, parseInt(trigger.getAttribute('data-line-change'), 10) || 0);
    var page = trigger.closest('[data-cart-page]');
    line.classList.add('is-loading');
    if (page) page.classList.add('is-loading');

    postJSON(routes.cartChange || '/cart/change.js', {
      id: line.getAttribute('data-line-key'),
      quantity: quantity,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    }).then(function (data) {
      if (page) { window.location.reload(); return; }
      renderDrawer(data.sections && data.sections['cart-drawer']);
    }).catch(function (error) {
      line.classList.remove('is-loading');
      if (page) page.classList.remove('is-loading');
      window.alert(error.message);
    });
  });

  /* ---------- Paiement Wave (Mohet Pay) ---------- */
  function waveBase() {
    var base = (RS.wave && RS.wave.base) || '/apps/payer';
    base = String(base).split('?')[0];
    return base.replace(/\/+$/, '');
  }

  var waveBusy = false;
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-wave-checkout]');
    if (!link) return;
    event.preventDefault();
    if (waveBusy) return;
    waveBusy = true;
    link.classList.add('is-busy');
    var label = link.querySelector('[data-wave-label]');
    if (label) {
      label.setAttribute('data-original', label.textContent);
      label.textContent = strings.openingWave || 'Ouverture du paiement…';
    }

    fetch(routes.cartJs || '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var totals = {};
        var order = [];
        (cart.items || []).forEach(function (item) {
          var key = String(item.variant_id);
          if (!(key in totals)) { totals[key] = 0; order.push(key); }
          totals[key] += item.quantity;
        });
        if (!order.length) { window.location.href = routes.cart || '/cart'; return; }
        var payload = order.map(function (key) { return key + ':' + totals[key]; }).join(',');
        window.location.href = waveBase() + '/p/panier?c=' + encodeURIComponent(payload);
      })
      .catch(function () { window.location.href = link.getAttribute('href'); });
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-wave-buy]');
    if (!link) return;
    var form = document.getElementById(link.getAttribute('data-form'));
    var idInput = form && form.querySelector('[name="id"]');
    var qtyInput = form && form.querySelector('[name="quantity"]');
    var variant = idInput && idInput.value;
    if (!variant || !/^\d+$/.test(String(variant))) return;
    event.preventDefault();
    var quantity = Math.max(1, Math.min(10, parseInt(qtyInput && qtyInput.value, 10) || 1));
    link.classList.add('is-busy');
    window.location.href = waveBase() + '/p?v=' + variant + '&q=' + quantity;
  });

  window.addEventListener('pageshow', function () {
    waveBusy = false;
    $$('.is-busy').forEach(function (el) { el.classList.remove('is-busy'); });
    $$('[data-wave-label][data-original]').forEach(function (el) { el.textContent = el.getAttribute('data-original'); });
  });

  /* ---------- Ouverture / fermeture ---------- */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-menu-open]')) { event.preventDefault(); openMenu(); return; }
    if (event.target.closest('[data-menu-close]')) { event.preventDefault(); closeMenu(); return; }
    var cartLink = event.target.closest('[data-cart-open]');
    if (cartLink) {
      if (document.body.classList.contains('template-cart')) return;
      event.preventDefault();
      closeMenu();
      openCart();
      return;
    }
    if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeCart(); }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { closeCart(); closeMenu(); }
  });

  window.RoyalSkin = Object.assign(window.RoyalSkin || {}, { formatMoney: formatMoney, waveBase: waveBase });
})();